module.exports = __webpack_public_path__ + "img/6tirGnoMov.82f27aae.png";